module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAABWElEQVQ4T72UMUsDQRCF37szGNDiYnGnvekEay0MpLMRC1ELf4G2l9gIRkEQklJUsBIVhSAWgpWNVhY2+gssBDkFLxALwx07rsVFDUmMMbrb7C4zH+/Nzi4dtzwEhtsAbbQ9JND5e17eWqeTKR0BMtM2q5pIkVhlgHa2dKaX478HAso0kv8AJF4EmO9i94VSlbRebwh4rxhLx4Pw9bOTII4kQnUVndVXKLLkFfrWoqD+jL+ioQsgFwXqC9CAOSiict8BJzTwNAqys/4kBSet1LiuQgVOP+WtYgRw3OdZre7wfS8im4Zh7lYVAUmK2m+sUHCj+8n1Ctb5h+VySjFc1SrHfgq89nqsEeQY1rOn26uo22uqmfVaywdePjHXKMF2/WUSw0I5jmKaXooILh8LiVQjoJPxd0C5iwXmVhTTStvcknyohera9UIwCurZZPzNS+n459Dp7+sNli7QyVWYOaoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jiangs.png
// module id = AnrX
// module chunks = 15